import { useState } from 'react';
import { YoutubeElement } from "@app/common";

type Properties = {
    data: YoutubeElement;
};

const Youtube = (props: Properties) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    return (
        <div className="page-youtube">
            {isLoading && (
                <div className="media-loading-overlay">Video wird geladen...</div>
            )}
            {hasError && (
                <div className="media-loading-overlay">Video konnte nicht geladen werden.</div>
            )}
            <iframe
                src={'https://www.youtube.com/embed/' + props.data.videoid + '?rel=0'}
                allowFullScreen={true}
                title={props.data.videoid}
                onLoad={() => {
                    setHasError(false);
                    setIsLoading(false);
                }}
                onError={() => {
                    setHasError(true);
                    setIsLoading(false);
                }}
            />
        </div>
    );
};

export default Youtube;